import * as React from "react";
import { connect } from "react-redux";
import { values } from "lodash";

import { getQuestionConfig } from "@teamprevent/common/questionnaires/questionnaireConfig";
import { getAnswerToQuestionWithId } from "@teamprevent/common/questionnaires/getAnswerToQuestionWithId";

import { OldProgressBarQuestionnaireSectionUnconnected } from "../../questionnaires/components/OldProgressBarQuestionnaireSection";
import { makeMapStateToQuestionnaireSectionProps, mapDispatchToQuestionnaireSectionProps } from "../../questionnaires/mappers";
import { HealthSurveillanceSectionProps } from "../models";
import * as questionIds from "../questions/questionIds";
import { TextQuestion } from "../../questionnaires/components/questions/TextQuestion";
import { MultiButtonQuestion, YesOption } from "../../questionnaires/components/questions/MultiButtonQuestion";
import { CheckboxQuestion } from "../../questionnaires/components/questions/CheckboxQuestion";
import { sections } from "../questionnaire";

const HealthSurveillancePitPupQuestionnaireSectionUnconnected: React.FunctionComponent<HealthSurveillanceSectionProps> =
    (props: HealthSurveillanceSectionProps) => {

        const questions = values(props.questions || {});
        const areFurtherDetailsMandatory: boolean = [
            getAnswerToQuestionWithId(questions, questionIds.IfAnsweredYesToAnyQuestionsAreSymptomsOngoingForLongerThan12Months),
            getAnswerToQuestionWithId(questions, questionIds.ConfirmThereHasBeenNoChangeToVisionOrOngoingMedicalConditionSinceLastF2FPitPupAssessment),
            getAnswerToQuestionWithId(questions, questionIds.AreAnySymptomsOrMedicationNewWithinLast12Months)
        ].findIndex(answer => answer === YesOption) !== -1;

        return (
            <OldProgressBarQuestionnaireSectionUnconnected
                {...props}
                {...sections.PitPupQuestionnaire}
            >
                <CheckboxQuestion
                    readonly={props.readonly}
                    questionConfig={getQuestionConfig(
                        props.questionConfigs,
                        questionIds.UnderstandCompleteAnnualSelfDeclarationToContinueWorkingAsPitPupDriver
                    )}
                    value="Confirmed"
                    mandatory
                />
                <CheckboxQuestion
                    readonly={props.readonly}
                    questionConfig={getQuestionConfig(
                        props.questionConfigs,
                        questionIds.UnderstandFailureToDiscloseInformationMayResultInTerminationOfContractOfEmployment
                    )}
                    value="Confirmed"
                    mandatory
                />
                <MultiButtonQuestion
                    readonly={props.readonly}
                    questionConfig={getQuestionConfig(props.questionConfigs, questionIds.IfAnsweredYesToAnyQuestionsAreSymptomsOngoingForLongerThan12Months)}
                    mandatory
                />
                <MultiButtonQuestion
                    readonly={props.readonly}
                    questionConfig={getQuestionConfig(
                        props.questionConfigs,
                        questionIds.ConfirmThereHasBeenNoChangeToVisionOrOngoingMedicalConditionSinceLastF2FPitPupAssessment
                    )}
                    mandatory
                />
                <MultiButtonQuestion
                    readonly={props.readonly}
                    questionConfig={getQuestionConfig(props.questionConfigs, questionIds.AreAnySymptomsOrMedicationNewWithinLast12Months)}
                    mandatory
                />
                <TextQuestion
                    readonly={props.readonly}
                    questionConfig={getQuestionConfig(props.questionConfigs, questionIds.PitPupMedicalsFurtherDetails)}
                    multiline
                    mandatory={areFurtherDetailsMandatory}
                />
            </OldProgressBarQuestionnaireSectionUnconnected>
        );
    };

export const HealthSurveillancePitPupQuestionnaireSection =
    connect(makeMapStateToQuestionnaireSectionProps(sections.PitPupQuestionnaire.id), mapDispatchToQuestionnaireSectionProps)
    (HealthSurveillancePitPupQuestionnaireSectionUnconnected);
